import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class ManageSubsellerService {

    constructor(private _http: HttpClient) { }

    getcandfrequest(data) {
        return this._http.post(environment.api_url + 'seller/candf/subsellerrequestlist', data);
    }

    getcandfsellers(data) {
        return this._http.post(environment.api_url + 'seller/candf/subsellerapprovelist', data);
    }

}
